import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import * as _ from 'lodash';

import { Config } from '../config/env.config';

import { BaseHttpService } from '../base/_base-http.service';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class PermissionsService extends BaseHttpService {

    private permissions: Array<string> = null;
    private permissionsSubj = new Subject<any>();

    get permissionsChange() {
      return this.permissionsSubj.asObservable();
    }

    getPermissions(): Observable<any> {
      return new Observable(observer => {
        if (this.permissions && !_.isString(this.permissions)) { // not error string
            observer.next(this.permissions);
            return observer.complete();
        } else {
          this.http.get(`${Config.API}/user/${this.brandService.getBrand()}/permissions`)

              .pipe(map( (res: any) => <Array<string>>_.map(res, 'permission') ),
                  catchError(this.handleError.bind(this)))
              .subscribe((permissions: any) => {
                  this.permissions = permissions;
                  this.permissionsSubj.next(permissions);
                  observer.next(this.permissions);
                  observer.complete();
              });
        }
    });
    }

    storePermissions(permissions: Array<string>): void {
      this.permissions = permissions;
      this.permissionsSubj.next(permissions);
    }

    clearStoredPermissions() {
      this.permissions = null;
      this.permissionsSubj.next(this.permissions);
    }

    hasPermission(permissions: Array<string>|string, requireAll: boolean= false): boolean {
      if (_.isString(permissions)) { permissions = [permissions]; }

      return !!_.intersection(this.permissions, permissions).length;
    }
}
